import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "content"];
  static values = { defaultTab: String };

  connect() {
    this.showTab(
      this.defaultTabValue ||
        this.tabTargets[0]?.getAttribute("data-tab") ||
        "errors",
    );
  }

  switchTab(event) {
    const targetTab = event.currentTarget.getAttribute("data-tab");
    this.showTab(targetTab);
  }

  showTab(targetTab) {
    if (!targetTab) return;

    // Hide all content
    this.contentTargets.forEach((content) => {
      content.classList.remove("active");
      content.classList.add("hidden");
    });

    // Reset all tab styles
    this.tabTargets.forEach((tab) => {
      tab.classList.remove(
        "active",
        "border-red-500",
        "text-red-600",
        "border-yellow-500",
        "text-yellow-600",
        "border-blue-500",
        "text-blue-600",
        "border-cta",
        "text-cta",
      );
      tab.classList.add(
        "border-transparent",
        "text-gray-500",
        "hover:text-gray-700",
        "hover:border-gray-300",
      );
    });

    // Show target content
    const targetContent = this.contentTargets.find(
      (content) => content.getAttribute("data-tab") === targetTab,
    );

    if (targetContent) {
      targetContent.classList.remove("hidden");
      targetContent.classList.add("active");
    }

    // Update target tab style
    const targetTabElement = this.tabTargets.find(
      (tab) => tab.getAttribute("data-tab") === targetTab,
    );

    if (targetTabElement) {
      targetTabElement.classList.add("active");
      targetTabElement.classList.remove(
        "border-transparent",
        "text-gray-500",
        "hover:text-gray-700",
        "hover:border-gray-300",
      );

      // Apply appropriate color based on tab type
      switch (targetTab) {
        case "absences":
          targetTabElement.classList.add("border-red-500", "text-red-600");
          break;
        case "latenesses":
          targetTabElement.classList.add(
            "border-yellow-500",
            "text-yellow-600",
          );
          break;
        case "errors":
          targetTabElement.classList.add("border-red-500", "text-red-600");
          break;
        case "warnings":
          targetTabElement.classList.add(
            "border-yellow-500",
            "text-yellow-600",
          );
          break;
        case "recommendations":
          targetTabElement.classList.add("border-blue-500", "text-blue-600");
          break;
        default:
          targetTabElement.classList.add("border-cta", "text-cta");
      }
    }
  }
}
